import "./utils/consoleSilencer";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as $ from "jquery";

// In development mode, we'll load the test utilities
if (process.env.NODE_ENV !== 'production') {
  // We use require instead of import for conditional loading
}
window.jQuery = window.$ = $;

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
